import { Table } from '@mantine/core'

import { TableItem } from '@/modules/employerAdvisors/pages/components/TableItem/TableItem'
import type { TableListProps } from '@/modules/employerAdvisors/pages/components/TableList/TableList.types'

export function TableList({ items }: TableListProps) {
  return (
    <Table.Tbody>
      {items.length === 0 ? (
        <TableItem empty />
      ) : (
        items.map(advisor => <TableItem key={advisor.id} item={advisor} />)
      )}
    </Table.Tbody>
  )
}
